import { useState } from "react";

const CustomAlert = ({ message, type = "warning", dismissible = false }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  // Define hex colors for different alert types
  const colors = {
  warning: { bg: "#30160E", text: "#fff" }, // yellow background, orange text
  success: { bg: "#D4EDDA", text: "#295B24" }, // green bg, dark green text
  error: { bg: "#F8D7DA", text: "#721C24" }, // keeping red
  info: { bg: "#CC9965", text: "#2A1008" }, // tertiary bg, text color
  secondary: { bg: "#eee", text: "#30160E" },
    yellow: { bg: "#f5e8bdff", text: "#30160E" },
  };

  const alertColors = colors[type] || colors.warning;

  return (
    <div
      className="font-mono"
      style={{
        backgroundColor: alertColors.bg,
        color: alertColors.text,
        padding: "0.5rem 0.75rem",
        borderRadius: "0.5rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span className="text-18pt">{message}</span>
      {dismissible && (
        <button
          onClick={() => setVisible(false)}
          style={{
            marginLeft: "1rem",
            fontWeight: "bold",
            fontSize: "1rem",
            lineHeight: "1",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: alertColors.text,
          }}
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default CustomAlert;
